const esJSON = {
  'Accent Sidebar': 'Barra lateral de acento',
  'your_analytics': 'Estas son tus estadísticas analíticas de hoy'
};

export default esJSON;
